import React from 'react';
import "./loading.css"
import phone from "../../res/img/spinner.svg";
const Loading = () => {
    return (
       <img src={phone}/>
    );
};

export default  Loading;
